import { render, staticRenderFns } from "./serOrganList.vue?vue&type=template&id=49b400ac&scoped=true"
import script from "./serOrganList.vue?vue&type=script&lang=js"
export * from "./serOrganList.vue?vue&type=script&lang=js"
import style0 from "./serOrganList.vue?vue&type=style&index=0&id=49b400ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b400ac",
  null
  
)

export default component.exports